/* eslint-disable ember/no-computed-properties-in-native-classes */
import Goal from '@linc-technologies/linced-common/models/goals/goal';
import { computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import type State from '@linc-technologies/linced-common/models/goals/state';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';

// Proto: goals.Goal.
export default class _Goal extends Goal {
  declare [Type]: 'goals/goal';

  @computed('states.content.@each.person_id')
  get statesByLearner() {
    const states = resolved(this.states);
    // person_id is null until the person loads, so the key is then 'null'.
    return states.reduce<Record<string, State[]>>((byLearner, state) => {
      if (isEmpty(byLearner[state.person_id!])) {
        byLearner[state.person_id!] = [];
      }
      byLearner[state.person_id!]!.push(state);
      return byLearner;
    }, {});
  }
}
